export default __webpack_public_path__ + "static/media/fire-pit.f293dc03.jpg";